export const cities = [
  {
    // htmlFor: "syd",
    // id: "syd",
    value: "sydney",
    label: "Sydney",
  },
  {
    // htmlFor: "melb",
    // id: "melb",
    value: "melbourne",
    label: "Melbourne",
  },
  {
    // htmlFor: "brisb",
    // id: "brisb",
    value: "brisbane",
    label: "Brisbane",
  },
  {
    // htmlFor: "perth",
    // id: "perth",
    value: "perth",
    label: "Perth",
  },
  {
    // htmlFor: "adld",
    // id: "adld",
    value: "adelaide",
    label: "Adelaide",
  },
  {
    // htmlFor: "canbr",
    // id: "canbr",
    value: "canberra",
    label: "Canberra",
  },
  {
    // htmlFor: "hbrt",
    // id: "hbrt",
    value: "hobart",
    label: "Hobart",
  },
  {
    // htmlFor: "drwn",
    // id: "drwn",
    value: "darwin",
    label: "Darwin",
  },
];
